import {useCallback, useEffect, useRef} from "react";
import {getOverflowRatio, isOverflown} from "../../../utils/DOMUtils";
import {catchify} from "../../../utils/Utils";
import useWindowSize from "../../../hooks/useWindowSize";
import {debounce} from "lodash";

const FitText = ({children, className}) => {
    const ref = useRef(null);

    const {width, height} = useWindowSize();

    const onResize = useCallback(() => {
        const element = ref?.current;
        if (element) {
            element.style.fontSize = "";
            if (isOverflown(element)) {
                const fontSize = parseFloat(getComputedStyle(element).fontSize);
                const ratio = getOverflowRatio(element);
                element.style.fontSize = `${Math.floor(ratio * fontSize)}px`;
            }
        }
    }, [ref]);

    useEffect(() => {
        let resizeObserver = null;
        const debouncedOnResize = debounce(onResize, 100);
        catchify(() => {
            if (ref?.current) {
                resizeObserver = new ResizeObserver(debouncedOnResize);
                resizeObserver.observe(ref.current);
            }
        })();
        onResize();
        return () => {
            debouncedOnResize.cancel();
            if (resizeObserver?.disconnect) resizeObserver.disconnect();
        };
    }, [onResize, ref, children?.length, width, height]);

    return (
        <div ref={ref} className={className}>
            {children}
        </div>
    );
};

export default FitText;
